
import { ArtCategory, ArtItem } from './types';

export const DATA_VERSION = 2000; 

export const MASTER_FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=1200&q=80';

export const DEFAULT_CATEGORY_COVERS: Record<string, string> = {
  [ArtCategory.ANIMATED]: 'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?w=800',
  [ArtCategory.STATIC]: 'https://images.unsplash.com/photo-1579546126580-593877242d51?w=800',
  [ArtCategory.BLACK_AND_WHITE]: 'https://images.unsplash.com/photo-1515462277126-2dd0c162007a?w=800',
  [ArtCategory.WORKSHOP]: 'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?w=800',
  [ArtCategory.AVATAR]: 'https://images.unsplash.com/photo-1557683316-973673baf926?w=800',
  [ArtCategory.CLIENT_ORDERS]: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800',
  'HOME_BG': 'https://images.unsplash.com/photo-1574067761451-3152f9ecd923?q=50&w=1200&auto=format&fit=crop'
};

export const INITIAL_ARTS: ArtItem[] = [
  {
    id: 'DEMO-1',
    title: { pt: 'Essência de Cerejeira', en: 'Sakura Essence' },
    category: ArtCategory.ANIMATED,
    price: 3.00,
    imageUrl: 'https://images.unsplash.com/photo-1522383225653-ed111181a951?w=800&q=80',
    videoUrl: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExaTN3NWJtMm1rbXg2cjAwbHNmdmZkaDg2M2d4NzFkOWd0OTlwc3Q3NyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/JDtoKaAUiTDxjnSj7s/giphy.mp4',
    steamBackgroundUrl: 'https://steamcommunity.com/market/listings/753/264320-Sakura%20Spirit%20Background',
    description: { pt: 'Estética clássica de cerejeiras sob o luar.', en: 'Classic cherry blossom aesthetic under the moonlight.' },
    isAnimated: true
  },
  {
    id: 'DEMO-2',
    title: { pt: 'Oni Cyberpunk', en: 'Cyberpunk Oni' },
    category: ArtCategory.BLACK_AND_WHITE,
    price: 5.00,
    imageUrl: 'https://images.unsplash.com/photo-1614728263952-84ea256f9679?w=800&q=80',
    videoUrl: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExM2o3dGdyZW1iaXp6NGozeXo2cmZueWFpZXE5Mzh6YTFpOW96N3JpciZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/3o7TKMG78pxg1I59V6/giphy.mp4',
    description: { pt: 'Estilo Noir futurista com traços de nanquim.', en: 'Futuristic Noir style with ink strokes.' },
    isAnimated: true
  },
  {
    id: 'DEMO-3',
    title: { pt: 'Jardim Zen', en: 'Zen Garden' },
    category: ArtCategory.STATIC,
    price: 2.00,
    imageUrl: 'https://images.unsplash.com/photo-1542002103-6f3458a2e519?w=800&q=80',
    description: { pt: 'Paz absoluta para o seu perfil.', en: 'Absolute peace for your profile.' },
    isAnimated: false
  },
  {
    id: 'DEMO-4',
    title: { pt: 'Nanquim Sagrado', en: 'Sacred Ink' },
    category: ArtCategory.ANIMATED,
    price: 7.00,
    imageUrl: 'https://images.unsplash.com/photo-1512418490979-92798ccc13b0?w=800&q=80',
    videoUrl: 'https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExMmxpZTNubmEyaDFobm9ndHJpbmR2NW0xeG1pZnhrYnZ2djB6bW9reCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/l0HlS6yLsc5t155wA/giphy.mp4',
    description: { pt: 'A pureza do traço oriental em movimento.', en: 'The purity of oriental strokes in motion.' },
    isAnimated: true
  }
];
